import React from 'react';
import PropTypes from 'prop-types';
import { MinusCheckbox, Check } from 'assets/icons';

import * as S from './Checkbox.styled';

// eslint-disable-next-line react/display-name
const Checkbox = React.memo(
  ({
    id,
    name,
    onChange,
    isChecked = false,
    isDisabled = false,
    isOpenGroup = false,
    label,
    style,
    labelStyle,
  }) => {
    const [checked, setChecked] = React.useState(isChecked);

    React.useEffect(() => {
      setChecked(isChecked);
    }, [isChecked]);

    const _onChange = () => {
      setChecked(!checked);
      onChange(!checked, name);
    };

    return (
      <S.Container style={style}>
        <S.StyledLabel isChecked={checked} isDisabled={isDisabled} htmlFor={id}>
          {checked && isOpenGroup && <MinusCheckbox />}
          {checked && !isOpenGroup && <Check />}
          <S.Checkbox
            id={id}
            name={name}
            checked={checked}
            onChange={_onChange}
            disabled={isDisabled}
          />
        </S.StyledLabel>
        {label && (
          <label style={labelStyle} htmlFor={id}>
            {label}
          </label>
        )}
      </S.Container>
    );
  },
);

Checkbox.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onChange: PropTypes.func.isRequired,
  isChecked: PropTypes.bool,
  isDisabled: PropTypes.bool,
  isOpenGroup: PropTypes.bool,
};

export default Checkbox;
